import React, { TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { FormTextInputProps } from './FormTextInputProps';

const normalizeDisplayName = (input: string): string => {
	if (input.length === 0) {
		return input;
	}
	const words = input.split(/(?=[A-Z])/);
	const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
	return capitalizedWords.join(' ');
};

export const FormTextInput = ({ name, type, disabled }: FormTextInputProps) => {
	type ??= 'text';
	const methods = useFormContext();
	const displayName = normalizeDisplayName(name);
	return (
		<TextField
			label={displayName}
			size='small'
			type={type}
			disabled={disabled}
			{...methods.register(name)}
			error={!!methods.formState.errors[name]}
			helperText={methods.formState.errors[name]?.message as string}
			required
			fullWidth
		/>
	);
};
